<!--
    校区管理-授权擎想系统
    作用：授权擎想系统的课件列表
    说明：旧版本
-->
<template>
  <div v-loading="loading">
    <div class="radio-tab">
      <el-radio-group v-model="radioTab" @change="TabChange">
        <el-radio-button label="xq">校区</el-radio-button>
        <el-radio-button label="pt">平台</el-radio-button>
      </el-radio-group>
    </div>

    <div class="auth-box">
        <CataLog
          ref="catalog"
          :default-select-structure.sync="defaultData"
          :select-stru.sync="curSelectStructure"
          :default-value.sync="selectCatalog"
          @onCatalog="onCatalog"
          @onSelectedIds="onSelectedIds"
          @onStructure="onStructure"
          @onCheck="onCheck"
        />
        <div class="table-box">
          <div class="btns">
            <el-button
              type="small"
              @click="nosave()"
            >取消授权</el-button>
<!--            <el-button type="small" @click="reset">重置</el-button>-->
          </div>
          <IMTable
            ref="refTable"
            :is-loading="isLoading"
            :is-operation.sync="operating"
            :all-select="true"
            :is-select="true"
            :selection="true"
            :is-page="true"
            :table-head.sync="tableHead"
            :table-data.sync="tableData"
            :pagination="{
              currentPage: meta.current_page,
              pageSize: meta.per_page,
              total: meta.total
            }"
            @onSelectType="onSelectType"
            @onSelection="onSelection"
            @onSearch="onSearch"
            @currentChange="currentChange"

            :is-radio="radioArr"
            :radio-type="checkLabel"
            @radioChange="radioChange"
          />
        </div>
      </div>
  </div>
</template>

<script>
import CataLog from './components/catalog';
import { tableData, tableHead } from './fields';

export default {
  name: 'campusYunPt',
  inject: ['reload'],
  components: {
    CataLog,
  },
  data() {
    return {
      id: this.$route.query.id,
      loading: false,
      radioTab: 'pt',
      tempIds: [], // 临时id集合
      operating: false, // 是否正在操作
      defaultData: [], // 历史数据
      defaultTreeSelecteds: [], // 默认树形选中
      curCatalogId: '', // 挡墙选中的目录id
      curSelectStructure: '', // 当前选中的学科
      selectCatalog: [], // 选中的目录集合
      selectedData: [], // 选中列表id集合
      course_selected: [], // 选中列表id集合
      course_unselected: [], // 未选中列表id集合

      curSelectType: '',
      search: '',
      isLoading: false,
      tableHead,
      tableData,
      meta: {
        current_page: 1,
        per_page: 15,
        total: 1,
      },
      curSelecteds: [],
      // 当前选中的所有集合
      curSelectedAll: [],

      radioArr: [{label: '2', text: '课件编辑权限'}, {label: '1', text: '上课权限'}],
      checkLabel: '2', // AI课件和AI双师课 切换
      radioAll: [], // 最终选择数据
      course_type: [],
    };
  },
  computed: {
    // course_selected(){
    //   let data = []
    //   try {
    //     let tempArr = []
    //     let temp = this.selectedData.filter(v=>v.type==='selected')
    //     data = temp.map(v=>v.course_ids)
    //     data.map(v=>{
    //       tempArr = tempArr.concat(v)
    //     })
    //   } catch (e) {
    //
    //   }
    //   return data
    // },
    // course_unselected(){
    //   let data = []
    //   try {
    //     let tempArr = []
    //     let temp = this.selectedData.filter(v=>v.type==='unselected')
    //     data = temp.map(v=>v.course_ids)
    //     data.map(v=>{
    //       tempArr = tempArr.concat(v)
    //     })
    //   } catch (e) {
    //
    //   }
    //   return data
    // },
    // 整合数据给予服务端
    choiceData() {
      let selecte_data = this.selectedData
      return {
        // 增加学科ID
        subject_id: this.curSelectStructure,
        structure_selected: this.selectCatalog,
        // 约定的组装数据，如果为传空则表示删除此学科所有课件授权。
        course_selected: this.course_selected,
        course_unselected: this.course_unselected
      };
    },
    structure_id_all(){
      let arr = []
      try {
        arr = [...this.$refs.catalog.getCheckeds(), ...this.$refs.catalog.getHalfCheckedKeys()]
      }catch (e) {
        console.log('获取所有选中树id失败==>', arr)
      }
      return arr
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
  // mounted() {
  // this.$nextTick(() => {
  //   setTimeout(() => {
  //     this.save();
  //   }, 3000);
  // });
  // },
  created () {

  },
  methods: {
    radioChange (label) {
      this.checkLabel = label;
      this.flashData({ newPage: 1, callback: this.setTableSelects, initial: true });
    },
    TabChange () {
      if (this.radioTab === 'xq') {
        this.$router.push({
          path: '/campus/yun',
          query: {
            id: this.id
          }
        });
      }
    },
    init() {
      // 获取默认数据
      this.getDefaultData();

      this.flashData({ newPage: 1, callback: this.setTableSelects, initial: true });
    },
    getSelectIndex(data, id){
      let index = -1
      try {
        let newId
        data.map((v, i) => {
          newId = typeof v === 'object'?v.id:v
          if(`${newId}`===`${id}`){
            index = i
          }
        })
      } catch (e) {
        console.log('获取索引失败==>', e)
      }
      return index
    },
    // 全选时判断当前是否为为非选中
    isSelectedAll(item){
      let state = true
      if(this.course_unselected.includes(item.id)) {
        state = false
      }
      return state
    },
    // 未全选 判断当前是否选中
    isSelected(item){
      let state = false
      if(this.course_selected.includes(item.id)) {
        state = true
      }
      return state
    },
    // 类型选择
    onSelectType(value) {
      this.curSelectType = value;
    },
    onSelectedIds(data) {
      this.selectCatalog = data;
    },
    async getDefaultData(isFlash) {
      // const type = 1; // 【服务端】预留类型
      // const schoolId = this.id;
      // const res = await this.$http.get(`/api/service/operate/auth/course_ware/${type}/${schoolId}`);
      // console.log('获取默认数据==>', res);
      // // 对历史数据做一层校验
      // this.defaultData = res.data;
      // if(isFlash){
      //   this.setDefaultHistory()
      // }
    },
    setDefaultHistory() {

      // console.log('setDefaultHistory==>before', this.defaultData);
      this.defaultData.map((v) => {
        const obj = {};
        if (`${v.subject_id}` === `${this.curSelectStructure}`) {
          // 旧数据兼容
          let course_selected = v.course_selected
          let course_unselected = v.course_unselected
          let structure_selected = v.structure_selected
          if(!course_selected && !course_unselected && !structure_selected && v.choice_data_json){
            course_selected = this.getOldSelected(v.choice_data_json.selecte_data.filter(v=>v.type==='selected'))
            course_unselected = this.getOldSelected(v.choice_data_json.selecte_data.filter(v=>v.type==='unselected'))
            structure_selected = v.choice_data_json.structure_id_all
          }
          // 旧数据中 如果选中和未选中都有值，则删除为选中的值
          [course_unselected, course_selected] = this.uniqueArrays(course_unselected, course_selected)

          this.course_selected = course_selected || []
          this.course_unselected = course_unselected || []
          this.selectCatalog = structure_selected || []
        }
      });
    },
    // 返回去重后点两数组
    uniqueArrays(arr1, arr2) {
      for (let i = 0; i < arr1.length; i++) {
        for (let j = 0; j < arr2.length; j++) {
          if (arr1[i] === arr2[j]) {
            arr1.splice(i, 1); //利用splice函数删除元素，从第i个位置，截取长度为1的元素
          }
        }
      }
      return [arr1, arr2];
    },
    // 兼容旧数据
    getOldSelected(arr){
      let data = []
      try {
        arr.map(v=>{
          data = data.concat(v.course_ids)
        })
        data = [...new Set(data)]
      } catch (e) {
        console.log('转换旧数据失败==>', e)
      }
      return data
    },
    onStructure(value) {
      this.curSelectStructure = value;
      console.log('onStructure==>');
      setTimeout(() => {
        this.$nextTick(() => {
          this.setDefaultHistory();
        });
      });
    },
    onCheck(data, node) {
      console.log('结构id==>', this.selectCatalog)
      this.selectCatalog = node.checkedKeys
      this.save(true)
      console.log(' onCheck目录选中==>', data, node, this.selectedData);
      this.selectCatalog = node.checkedKeys
      data.leaf = true;
      if (data.leaf) {
        this.curCatalogId = data.id
        setTimeout(() => {
          this.flashData({ newPage: 1, callback: this.setTableSelects });
        }, 200);
      } else {
        // 如果组变更 子分类在里面，则重新刷新
        this.tempIds = []
        this.getIdsByTree(data.children)
        let ids = [data.id].concat(this.tempIds)
        if(ids.includes(this.curCatalogId)){
          setTimeout(() => {
            this.flashData({ newPage: 1, callback: this.setTableSelects });
          }, 200);
        }
      }
    },
    // 获取整个树的id集合
    getIdsByTree(data){
      data.map(v=>{
        this.tempIds.push(v.id)
        if(v.children && v.children.length>0){
          this.getIdsByTree(v.children)
        }
      })
    },
    onCatalog(data, node) {
      // 当选中目录是最后一片叶子时, 刷新数据
      if (node.isLeaf && data.id !== this.curCatalogId) {
        this.curCatalogId = data.id;
        this.flashData({ newPage: 1, callback: this.setTableSelects });
      }
    },
    // 翻页
    currentChange(page) {
      this.flashData({ newPage: page, callback: this.setTableSelects });
    },
    async flashData({ newPage, callback, initial }) {
      /*if (!this.curCatalogId) {
        !initial && this.$message.error('请先选中目录');
        return false;
      }*/
      let page = 1;
      if (newPage) {
        page = newPage;
      }
      this.isLoading = true;

      let url = `/api/service/operate/auth_list?equal[open@to_clients_id]=${this.id}&type=${this.checkLabel}`;

      if (this.search) {
        const name = this.curSelectType || 'name';
        url += `&like[${name}]=${this.search}`;
      }
      if (page) url += `&page=${page}`;
      const res = await this.$http.get(url);
      console.log('校区列表==>', res);
      const arr = res.items.map(v => ({
        ...v,
        name: v.name,
        title: v.title,
        category_name: v.category_name,
        type: (function () {
          switch (v.type) {
            case 'online': return '线上课件'; break;
            case 'offline': return '线下课件'; break;
            case 'double_teacher': return '双师课件'; break;
          }
        })(),
        package_status: (function () {
          switch (v.package_status) {
            case 'unpublished': return '未发布'; break;
            case 'success': return '发布成功'; break;
            case 'failure': return '发布失败'; break;
            default: return '未发布'
          }
        })(),
        school_name: v.school_name,
        create_name: v.create_name,
        mobile: v.mobile,
        update_name: (function () {
          return v.update_name || '--'
        })(),
      }));
      this.meta = {
        current_page: res.meta.current_page,
        per_page: res.meta.per_page,
        total: res.meta.total,
      };
      this.tableData = arr;
      this.isLoading = false;
      this.$nextTick(() => {
        callback && callback();
      });
    },
    onSearch(value) {
      this.search = value;
      this.flashData({ newPage: 1, callback: this.setTableSelects });
    },
    onSelection(selecteds, row) {
      console.log('111==>', selecteds,row)

      let index = -1
      this.selectCatalog.map((v,i)=>{
        if(`${v}`=== `${this.curCatalogId}`){
          index = i
        }
      })
      // 全选
      if(!row){
        // 1.如果选中列表为空表示全不选
        // 2.否则为全选
        if(selecteds.length === 0){
          console.log('全不选')
          // 3.1.删除全选目录对应的id
          if(index > -1) this.selectCatalog.splice(index, 1)
        } else{
          console.log('全选')
          // 3.2.添加当前目录为全选目录
          if(index === -1) this.selectCatalog.push(this.curCatalogId)
        }
        this.$refs.catalog && this.$refs.catalog.setCheckedKeys(this.selectCatalog)
        // this.flashData({ newPage: 1, callback: this.setTableSelects, initial: true })
        this.setTableSelects();
        return false
      }

      let rowSelected = false
      if (selecteds) {
        let index = this.getSelectIndex(selecteds, row.id)
        if(index>-1) rowSelected = true
      }
      // 行未选中
      if(!rowSelected) {
        console.log('行未选中')
        // 1.如果当前目录为全选 则判断为选中id是否存在 为选中列表
        let deleteIndex = this.getSelectIndex(this.course_selected, row.id)
        if(deleteIndex>-1) this.course_selected.splice(deleteIndex, 1)
        if(index>-1){
          if(!this.course_unselected.includes(row.id)) {
            this.course_unselected.push(row.id)
          }
        } else {
            let deleteIndex2 = this.getSelectIndex(this.course_unselected, row.id)
            if(deleteIndex2>-1) this.course_unselected.splice(deleteIndex, 1)
        }
      }
      // 行选中
      else{
        console.log('行选中')
        // 2.如果当前目录为全选 否则判断选中中是否存在，不存在就添加
        let deleteIndex = this.getSelectIndex(this.course_unselected, row.id)
        if(deleteIndex>-1) this.course_unselected.splice(deleteIndex, 1)

        if(index == -1){
          if(!this.course_selected.includes(row.id)) {
            this.course_selected.push(row.id)
          }
        }
      }
    },
    changeSelectData({ structureId, selecteds, isAll }) {
      if (!this.selectedData[`${structureId}`]) {
        this.selectedData[`${structureId}`] = {};
      }
      const data = JSON.parse(JSON.stringify(this.selectedData));
      if (isAll) {
        data[`${structureId}`].unselected = this.getUnselected({ data: data[structureId].unselected, selecteds });
      } else {
        data[`${structureId}`].selected = this.getSelected({ data: data[structureId].selected, selecteds });
      }
      this.selectedData = JSON.parse(JSON.stringify(data));
    },
    // 更新未选中
    getUnselected({ data, selecteds }) {
      // 获取当前未选中id集合
      const newData = data || []; // 未选中集合
      this.tableData.forEach((v) => {
        if (selecteds.includes(v.id) && newData.indexOf(v.id) > -1) {
          newData.splice(newData.indexOf(v.id), 1);
        } else if (!selecteds.includes(v.id) && newData.indexOf(v.id) === -1) {
          newData.push(v.id);
        }
      });
      return newData;
    },
    // 更新选中
    getSelected({ data, selecteds }) {
      // 获取当前选中id集合
      const newData = [...(data || [])];
      this.tableData.forEach((v) => {
        if (selecteds.includes(v.id) && newData.indexOf(v.id) === -1) {
          newData.push(v.id);
        } else if (!selecteds.includes(v.id) && !(newData.indexOf(v.id) === -1)) {
          newData.splice(newData.indexOf(v.id), 1);
        }
      });
      return newData;
    },
    async save(isAuto) {
      return;

      const params = this.choiceData;
      // 获取树选中的所有节点 - 给予后端
      const type = 1;
      const schoolId = this.id;
      const res = await this.$http.post(`/api/service/operate/auth/course_ware/${type}/${schoolId}`, params);
      if (res && res.status_code === 200) {
        if(!isAuto){
          this.$message.success('保存成功');
          this.getDefaultData();
        }else{
          this.getDefaultData(true)
        }
      }
      console.log('保存==>', res);
    },

    // 获取学科结构选中的所有节点id
    getStructureIds(){
      if(Object.keys(this.selectedData).length>0) {
        let newArr = []
        // 获取选中的菜单列表id
        let selectArrs = Object.entries(this.selectedData).filter(v => {
          return (v[1].selected && v[1].selected.length > 0) ||
            (v[1].unselected && v[1].unselected.length > 0) ||
            ((v[1].selected && v[1].selected.length === 0) && (v[1].unselected && v[1].unselected.length === 0)) ||
            (v[1].selected && v[1].selected.length > 0 && !v[1].unselected)
        })
        return selectArrs.map(v => v[0])
      }
      return []
    },
    reset() {
      window.location.reload();
      // this.getDefaultData();
    },
    // 设置当前表格选中数据
    setTableSelects() {
      console.log('setTableSelects==>')
      // this.operating = true;
      // 获取当前配置判断 列表数据是否被选中
      // 全选处理
      if (this.selectCatalog.includes(this.curCatalogId)) {
        // debugger;
        this.tableData.map((v) => {
          console.log('设置当前表格选中数据==>', v);
          // 1.如果全选状态，判断非选中
          if(this.isSelectedAll(v)) {
            !this.course_selected.includes(v.id) && this.course_selected.push(v.id);
            this.$refs.refTable && this.$refs.refTable.setDefaultSelected(v);
          }
          return false;
        });
      }
      // 未全选 处理
      else {
        console.log('未全选 处理设置当前表格选中数据==>');
        // debugger;
        this.tableData.map((v) => {
          // 2.未全选,判断选中
          if(this.isSelected(v)) {
            this.course_selected.includes(v.id) && this.course_selected.splice(this.course_selected.findIndex(item => item === v.id), 1);
            this.$refs.refTable && this.$refs.refTable.cancelSelect(v);
          }
          return false;
        });
      }
      // this.save(true)
      // setTimeout(() => {
      //   this.operating = false;
      // }, 3000);
    },

    // 取消授权
    nosave () {
      const ids = this.choiceData.course_selected.join(',');

      if (ids) {
        this.loading = true;

        this.$http.post('/api/service/operate/auth/result/delete', {
          clients_id: this.id,
          type: this.checkLabel,
          ids,
        }).then(() => {
          this.$message.success('取消授权成功');
          this.reload();
          /*this.selectCatalog = [];
          this.setTableSelects();
          this.flashData({ newPage: 1, callback: this.setTableSelects });*/
        }).catch(res => this.$message.error(res.message)).finally(() => this.loading = false);
      } else {
        this.$message.warning('请先勾选课件');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.auth-box{
  min-width: 1138px;
  display: flex;
  flex-direction: row;
}
  .table-box{
    display: flex;
    flex-direction: column;
    width: 100%;

    .btns{
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/CampusManagement/campusYunPt/index.vue